import FieldFactory from './FieldFactory.js'
import Util from './Util.js'

const comparators = [ '>', '<', '=', '<>', '<=', '>=', 'LIKE', 'NOTLIKE', 'IN', 'NOTIN', 'NOT' ]

export default {
  id : 'Expression.FieldParser.ComparatorField',
  type : 'comparatorField',
  sort : -11,
  handles : ( field, context ) => {
    return field.type === 'ExpressionParser.Field' && !!Util.findRootToken( field.value, { token : comparators, context } )
  },
  parse : async ( field, context ) => {
    const hasAlias = Util.handleAlias( field.value, { context } )
    let value = field.value, alias
    if ( hasAlias ) {
      value = hasAlias.field
      alias = hasAlias.alias
    }
    const res = Util.findRootToken( value, { token : comparators, context } )
    // no need to null check res, the handles did it for us
    const comparator = res.match
    const childContext = {
      ...context,
      field : {
        ...field,
        type : 'ExpressionField.comparator',
        comparator,
      },
    }
    const left = await FieldFactory.create( res.pre, { ...childContext, indexOffset : res.relativeLocation.preIndex } )
    const right = await FieldFactory.create( res.post, { ...childContext, indexOffset : res.relativeLocation.postIndex } )
    const toReturn = {
      type : 'ExpressionField.comparator',
      comparator,
      left : left?.fields?.[0],
      right : right?.fields?.[0],
    }
    if ( hasAlias ) {
      toReturn.alias = alias
    }
    if ( context?.includeAstInfo ) {
      toReturn.absoluteLocation = {
        startIndex : field.startIndex,
        endIndex : field.startIndex +
          ( hasAlias ? hasAlias.field.length : field.value.length ),
      }
      toReturn.relativeLocation = {
        startIndex : 0,
        endIndex : hasAlias ? hasAlias.field.length : field.value.length
      }
      toReturn.comparatorLocation = {
        absoluteIndex : res.absoluteLocation.matchIndex,
        relativeIndex : res.relativeLocation.matchIndex,
      }
      toReturn.untrimmed = field.untrimmed
      if ( hasAlias ) {
        toReturn.aliasLocation = {
          absolute : hasAlias.absoluteLocation,
          relative : hasAlias.relativeLocation,
        }
      }
    }
    return toReturn
  }
}
